export default
{
  regular: {
    color: '#7b7b7b',
    text: 'Okresowe',
  },
  specific_day: {
    color: '#2d7084',
    text: 'Konkretny dzień',
  },
  permanent: {
    color: '#663399',
    text: 'Cykliczne',
  },
};
